import { render } from "./TheBattleInfo.vue?vue&type=template&id=b91c6686&bindings={\"myHp\":\"props\",\"enemyHp\":\"props\",\"myHpPercentage\":\"options\",\"enemyHpPercentage\":\"options\"}"
import script from "./TheBattleInfo.vue?vue&type=script&lang=js"
export * from "./TheBattleInfo.vue?vue&type=script&lang=js"

import "./TheBattleInfo.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script